import React from "react";
import { useFormikContext } from "formik";

export const RadioButtonField = ({
  fieldName,
  value,
  label,
  onBeforeChange,
  disabled,
  educacao,
  edit,
  loadingScroll,
  setScrollLoading,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const checked = values[fieldName] === value;

  const handleClick = async (e) => {
    const oldValue = values[fieldName];
    const newValue = value;

    if (newValue === oldValue) return;

    // se tiver onBeforeChange (alerta de confirmação)
    if (onBeforeChange) {
      e.preventDefault();
      const proceed = await onBeforeChange(newValue, oldValue);
      if (proceed) {
        setFieldValue(fieldName, newValue);
      }
      return;
    }

    // lógica para educacao
    if (educacao) {
      const isChecked = values[fieldName] === value;
      setFieldValue(fieldName, isChecked ? "N" : value);
      return;
    }

    // lógica para scroll
    if (loadingScroll && setScrollLoading) {
      if (fieldName === "compartilharProcesso" && value === "S") {
        setScrollLoading(true);
      } else {
        setScrollLoading(false);
      }
    }

    setFieldValue(fieldName, newValue); // comportamento padrão
  };

  return (
    <label
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        whiteSpace: "nowrap",
      }}
    >
      <input
        type="radio"
        name={fieldName}
        value={value}
        disabled={disabled}
        checked={checked}
        onClick={handleClick}
        onChange={() => {}}
        style={{
          cursor: "pointer",
          width: edit ? "20px" : undefined,
          height: edit ? "20px" : undefined,
        }}
      />
      <span style={{ marginLeft: "5px", whiteSpace: "normal" }}>{label}</span>
    </label>
  );
};
